function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsiteLogo3Small2Cropped = function SvgAsiteLogo3Small2Cropped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.504,
    height: 31.429,
    style: {
      maxHeight: 500
    },
    viewBox: "0 0 31.504 31.429"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.668 0q3.23-.103 6.453-.148 1.093-.024 2.188-.059c5.441-.172 10.78.176 15.074 3.934.8.949.8.949.996 1.996-.195.902-.195.902-1.363 1.68-.75.12-.75.12-1.614.152l-.98.047c-.52.015-.52.015-1.05.035-.36.015-.72.027-1.087.047q-1.72.069-3.441.132c-1.145.047-2.29.09-3.438.141l-2.136.082q-.485.02-.98.04c-.286.01-.571.023-.864.03-.836.051-.836.051-1.918.461-.668 1.336-.445 2.867-.442 4.336v1.07c-.004.747 0 1.493 0 2.235.004 1.148 0 2.293-.004 3.437 0 .727.004 1.45.004 2.172 0 .344-.004.688-.004 1.043-.148 1.551-.148 1.551.446 2.852 5.418.293 10.617-.27 15.953-1.168l.023-1.277c.032-1.56.063-3.118.102-4.672l.039-2.028q.03-1.452.063-2.906c.007-.305.011-.605.015-.918.059-2.137.059-2.137.926-3.004 1.773.215 1.773.215 2.336.778.047 1.128.07 2.25.078 3.378 0 .34.004.68.004 1.032.004.722.008 1.449.008 2.172.004 1.101.02 2.207.03 3.308 0 .703.005 1.406.005 2.11.004.328.012.656.015.996-.007 1.82-.09 3.082-1.308 4.535-4.54 1.676-9.984 1.55-14.79 1.949q-.543.046-1.105.098c-4.261.332-4.261.332-5.957-.52-.785-.703-1.297-1.43-1.886-2.305q-.515-.672-1.036-1.34a359 359 0 0 1-1.105-1.46l-.54-.715c-1.23-1.723-1.23-1.723-1.124-2.883l.3-.617c1.56.39 1.56.39 3.895 2.73V7.012l-1.558-.778c-.68-.632-.68-.632-1.168-1.168l-.024 1.168q-.042 2.138-.097 4.282-.025.924-.043 1.855c-.016.887-.04 1.774-.063 2.664q-.005.414-.016.84c-.058 1.957-.058 1.957-.925 2.828-.825-.148-.825-.148-1.555-.39q-.058-3.204-.086-6.407-.013-1.09-.031-2.18c-.02-1.042-.028-2.09-.035-3.132l-.024-.985c0-2.25 0-2.25.899-3.484.832-.566.832-.566 1.855-.617 1.313.441 1.313.441 2.027.992 3.485 2.652 7.586 2.008 11.739 1.785l.96-.047c1.63-.086 3.25-.199 4.876-.343-2.98-1.985-5.953-1.711-9.387-1.606q-1.266.033-2.531.055-1.142.023-2.29.058c-1.37-.066-2.417-.343-3.69-.843C4.41 1.043 4.538.53 4.667 0m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#cc0101",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.809 2.727h5.058c.918 3.117 1.824 6.23 2.723 9.351.078.266.156.531.234.805.489 1.683.969 3.37 1.45 5.058q.241.83.476 1.66.34 1.178.672 2.356c.129.453.262.906.394 1.371.278 1.219.278 1.219.278 3.164h-3.89c-.263-.883-.52-1.77-.778-2.652-.145-.492-.29-.985-.442-1.492-.34-1.309-.34-1.309-.34-2.477h-6.613l-.34 1.996c-.289 1.598-.64 3.102-1.218 4.625h-3.891c.246-2.644.879-5.09 1.605-7.64.122-.426.239-.852.364-1.29.379-1.347.761-2.699 1.144-4.046l.774-2.746q.703-2.503 1.414-5c.14-.504.14-.504.285-1.016.2-.68.418-1.356.64-2.027m2.336 4.675c-.329 1.211-.653 2.418-.973 3.63q-.141.513-.281 1.038c-.09.332-.176.66-.266 1q-.122.456-.25.922c-.219.863-.219.863-.176 1.98h4.278a75 75 0 0 0-1.946-8.57zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#060907",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.762 3.117h14.398v3.508h-10.508v5.453h8.95v3.895h-8.95v6.625h10.895v3.507h-14.785zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#060808",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.594 2.973c1.535.87 2.441 1.773 3.402 3.261.317 1.508.317 1.508.39 2.727h-4.28c-.254-.645-.512-1.285-.778-1.95-.39-.472-.39-.472-1.164-.44-.473.003-.473.003-.953.003-.313 0-.625 0-.945-.004-.852 0-.852 0-1.606.442-.312 1.168-.515 1.992-.097 3.144.566.88.988 1.137 1.925 1.578.285.141.57.282.867.426.594.281 1.192.567 1.79.844 2.308 1.144 4.07 2.57 5.242 4.918.281 2.781.175 4.777-1.555 7.012-2.629 2.039-4.934 2.246-8.172 1.949-2.105-.625-3.457-1.66-4.672-3.508-.625-1.25-.41-2.508-.386-3.895h3.89c.203.653.203.653.414 1.317.547 1.277.692 1.383 2.043 2.02 1.54.183 2.375.054 3.77-.61.562-1.125.535-1.867.386-3.117-1.69-2.059-3.82-2.996-6.168-4.133-2.132-1.07-3.55-2.07-4.335-4.437-.227-2.227-.028-3.665 1.265-5.52 2.606-2.742 6.297-3.555 9.727-2.027m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#060907",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.008 3.117h10.894v3.508h-3.504v15.973h4.282v3.894H99.617v-3.894h3.89V6.625h-3.5zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#060808",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.133 3.117h15.953v3.508h-5.836v19.867h-4.281V6.625h-5.836zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#070807",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.953 10.91c3.281-.418 3.281-.418 4.703.55.68.7 1.297 1.423 1.914 2.177q.77.785 1.555 1.558l-.71.7c-.31.308-.622.613-.942.933-.325.317-.645.633-.977.961-.926.914-.926.914-1.676 2.129-.754.73-.754.73-1.535.762-.87-.102-.87-.102-2.332-.422.645-1.637 1.172-1.871 2.727-3.113-2.313.125-4.625.253-7.004.386v-2.726c3.465-.387 3.465-.387 7.004-.778-.45-.37-.899-.742-1.364-1.12-.765-.63-.765-.63-1.363-1.22zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.605 22.207H179v3.898h-3.89l-.391-2.73h-.778v2.73h-1.168v-2.73h-1.168zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#060807",
      fillOpacity: 1
    }
  }));
};
export default SvgAsiteLogo3Small2Cropped;